import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Base, toast } from '@itsrever/design-system'
import { listAllWithdrawalRequests } from '@/api/processes-api'
import { withdrawalsCsv } from './withdrawals-csv'

export const ExportWithdrawalsButton = ({
  ecommerceId
}: {
  ecommerceId: string
}) => {
  const { t } = useTranslation()
  const [exporting, setExporting] = useState(false)

  const exportCsv = async () => {
    setExporting(true)
    try {
      const rows = await listAllWithdrawalRequests(ecommerceId)
      // The BOM makes Excel read accented names as UTF-8.
      const blob = new Blob(['\uFEFF', withdrawalsCsv(rows)], {
        type: 'text/csv;charset=utf-8'
      })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `withdrawals-${ecommerceId}-${new Date().toISOString().slice(0, 10)}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    } catch {
      toast({ text: t('withdrawals.export_error'), variant: 'error' })
    } finally {
      setExporting(false)
    }
  }

  return (
    <Base.Button variant="primary" loading={exporting} onClick={exportCsv}>
      {t('orders.export_csv')}
    </Base.Button>
  )
}
